import React, { useState } from "react";
import { editiconorange, rightarrowwhite } from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import OtpInput from "react-otp-input";

import FullWidthTextField from "../../../components/TextField/FullWidthTextField";
import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import useTheme from "../../../components/useTheme/useTheme";

const EditOwnerEmailId = ({ lightTheme, value, onChange, error }) => {
    const { theme } = useTheme();
  return (
    <div className="field_wrapper padding_left">
      <TextFieldWithIcon
        label="Edit Owner/Founder Email Id*"
        icon={editiconorange}
        disabled={false}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        lightTheme={lightTheme}
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default EditOwnerEmailId;
